import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';

@Component({
  selector: 'app-alert-disable-model',
  templateUrl: './alert-disable-model.component.html',
  styleUrl: './alert-disable-model.component.scss',
  encapsulation:ViewEncapsulation.None
})
export class AlertDisableModelComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<AlertDisableModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.alertDisable)) {
      this.objectHash.primaryKey=this.dialogData.alertDisable.primaryKey;
      this.objectHash.database = this.dialogData.alertDisable.database;
      this.objectHash.schema = this.dialogData.alertDisable.schema;
      this.objectHash.server = this.dialogData.alertDisable.server;
      this.objectHash.appInstance = this.dialogData.alertDisable.appInstance;
      this.objectHash.dirPath = this.dialogData.alertDisable.dirPath;
      this.objectHash.isActive = this.dialogData.alertDisable.isActive;
      this.objectHash.isGlobal = this.dialogData.alertDisable.isGlobal;
      this.objectHash.whereClause = this.dialogData.alertDisable.whereClause;
    }
  }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
  startDate=new Date();
  endDate= new Date();
  objectHash = {
    primaryKey:'',
    database: '',
    schema: '',
    server: '',
    appInstance: '',
    dirPath: '',
    isActive: false,
    isGlobal: false,
    whereClause:'',
  }
  close() {
    this.dialogRef.close();
  }
  changeDate(event:Date|string) {
    
  }
 
  nextDisable(dateObj: any) {
    const currentDate = dateObj.date;
    dateObj.callback(new Date(currentDate.setDate(currentDate.getDate() + 1)) > new Date('2019-12-19'));
  }
 
  prevDisable(dateObj: any) {
    const currentDate = dateObj.date;
  }
  changeDate1(event:Date|string) {
    
  }
 
  nextDisable1(dateObj: any) {
    const currentDate = dateObj.date;
    dateObj.callback(new Date(currentDate.setDate(currentDate.getDate() + 1)) > new Date('2019-12-19'));
  }
 
  prevDisable1(dateObj: any) {
    const currentDate = dateObj.date;
  }

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.database)) {
      this.toaster.error('Database can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.schema)) {
      this.toaster.error('Schema can not be null');
      throw new Error();
    }if (this.fnutilservice.isEmptyObject(this.objectHash.server)) {
      this.toaster.error('Server can not be null');
      throw new Error();
    }if (this.fnutilservice.isEmptyObject(this.objectHash.appInstance)) {
      this.toaster.error('AppInstance can not be null');
      throw new Error();
    }if (this.fnutilservice.isEmptyObject(this.objectHash.dirPath)) {
      this.toaster.error('DirPath can not be null');
      throw new Error();
    }
    this.dialogRef.close(this.objectHash);
  }

}
interface HwDialogData {
  alertDisable: any;
}
